import type React from "react";
import { Link } from "react-router-dom";

const CTA: React.FC = () => {
	return (
		<section className="py-16 md:py-24 bg-blue-600">
			<div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
				<h2 className="text-3xl md:text-4xl font-bold text-white mb-6">
					あなたも学習ギルドで新しい一歩を踏み出しませんか？
				</h2>
				<p className="text-xl text-blue-100 mb-8">
					仲間と一緒に学び、成長する喜びを体験しましょう
				</p>
				<div className="flex flex-col sm:flex-row gap-4 justify-center">
					<Link
						to="/signup"
						className="inline-flex items-center justify-center px-8 py-3 border border-transparent text-base font-medium rounded-md text-blue-600 bg-white hover:bg-blue-50 md:py-4 md:text-lg md:px-10"
					>
						無料で始める
					</Link>
					<Link
						to="/contact"
						className="inline-flex items-center justify-center px-8 py-3 border border-white text-base font-medium rounded-md text-white hover:bg-blue-500 md:py-4 md:text-lg md:px-10"
					>
						お問い合わせ
					</Link>
				</div>
			</div>
		</section>
	);
};

export default CTA;
